import { Controller } from "@hotwired/stimulus"
import Tagify from '@yaireo/tagify'
import '@yaireo/tagify/dist/tagify.css'

export default class extends Controller {
  static targets = ["input"]

  connect() {
    this.tagify = new Tagify(this.inputTarget, {
      // 必要に応じてオプションを追加
      whitelist: [],
      dropdown: {
        enabled: 0
      }
    })
  }

  disconnect() {
    if (this.tagify) this.tagify.destroy()
  }
}
